import React from "react"
import styled from "styled-components"
import { object } from "prop-types"
import { Grid } from "../../atoms/grid"
import { Settings } from "../../../styles/theme"
import Brochure from "../../../images/brochure.png"
import Newsletter from "../../../images/newsletter.png"
import WWW from "../../../images/world-wide-web.png"
import { StaticQuery } from "gatsby"
import { FormCluster } from "../forms"
import { Download } from "../../forms"

const Downloadstyle = styled.div`
  position: relative;
  h4 {
    color: ${Settings.primaryColor};
    font-weight: bold;
    text-align: center;
  }
  .button {
    color: #fff;
    background: ${Settings.primaryColor};
    padding: 1rem 2rem;
    border: none;
    cursor: pointer;
    font-weight: 700;
    border-radius: 5px;
  }
  img {
    width: 64px;
    height: 64px;
  }
`

const DownloadCell = styled.div`
  position: relative;
  text-align: center;
  display: flex;
  justify-content: center;
  margin: 2rem 0;
  @media screen and (max-width: ${Settings.sizeM}) {
    flex: 1 1 48% !important;
    width: 48%;
  }
  > div {
    cursor: pointer;
    transition: border 175ms ease-in-out;
    border: 3px solid
      ${props =>
        props.selected ? Settings.secondaryColor : "rgba(0, 0, 0, 0)"};
    height: 180px;
    width: 220px;
    text-align: center;
    align-items: center;
    display: flex;
    justify-content: center;
    p {
      text-align: center;
      text-transform: uppercase;
    }
  }
`

const DownloadFormStyle = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  transition: opacity 175ms ease-in-out;
  pointer-events: ${props => (props.toggled ? "all" : "none")};
  opacity: ${props => (props.toggled ? "1" : "0")};
  > span {
    background: rgba(0, 0, 0, 0.7);
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 998;
    cursor: pointer;
  }
  > div {
    background: #fff;
    posiion: absolute;
    z-index: 999;
    width: 90%;
    margin: 0 auto;
    padding: 2rem 0;
    top: 50%;
    transform: translateY(-50%);
    height: 60vh;
    overflow-y: scroll;
  }
`

class DownloadFrame extends React.Component {
  state = {
    selected: [],
    toggled: false,
  }

  toggleUrl = item => {
    console.log(item)
    let array = this.state.selected
    const exists = array.includes(item)

    if (exists) {
      array = array.filter(c => {
        return c !== item
      })
    } else {
      array.push(item)
    }
    this.setState({
      selected: array,
    })
  }

  handleToggle = () => {
    this.setState({
      toggled: !this.state.toggled,
    })
  }

  render() {
    return (
      <Downloadstyle>
        <div className="constraint">
          {this.props.data.allContentfulDownloads.edges.map((category, i) => (
            <Grid columns={2}>
              <div>
                <h4>{category.node.categoryName}</h4>
              </div>
              <Grid columns={2}>
                {category.node.files.map((ref, i) => (
                  <DownloadCell
                    key={i}
                    selected={this.state.selected.includes(ref.file.url)}
                  >
                    <div onClick={() => this.toggleUrl(ref.file.url)}>
                      <div>
                        <img
                          src={
                            category.node.icon === "Brochure"
                              ? Brochure
                              : category.node.icon === "Globe"
                              ? WWW
                              : category.node.icon === "Newsletter"
                              ? Newsletter
                              : Brochure
                          }
                        />
                        <p>{ref.description}</p>
                      </div>
                    </div>
                  </DownloadCell>
                ))}
              </Grid>
            </Grid>
          ))}
        </div>
        <div className="constraint" style={{ textAlign: "center" }}>
          <button onClick={this.handleToggle} className="button">
            DOWNLOAD
          </button>
        </div>
        <DownloadFormStyle toggled={this.state.toggled}>
          <span className="overlay" onClick={this.handleToggle} />
          <FormCluster data={Download} downloads={this.state.selected} />
        </DownloadFormStyle>
      </Downloadstyle>
    )
  }
}

export const Downloads = ({ object }) => (
  <StaticQuery
    query={graphql`
      query DownloadQuery {
        allContentfulDownloads {
          edges {
            node {
              id
              categoryName
              icon
              files {
                id
                description
                file {
                  url
                }
              }
            }
          }
        }
      }
    `}
    render={data => <DownloadFrame data={data} object={object} />}
  />
)
